<script>
export default {
  name: 'ModalBase',
  data() {
    return {
      vis: false,
      loading: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.vis = this.outerVis
    })
  },
  model: {
    prop: 'outerVis',
    event: 'update:outerVis'
  },
  props: {
    outerVis: Boolean
  },
  methods: {},
  watch: {
    outerVis: {
      handler(nv) {
        this.$nextTick(() => {
          this.vis = nv
        })
      }
    },
    vis(nv) {
      if (!nv) {
        const { formRef } = this.$refs
        formRef && formRef.resetFields()
      }
      this.$emit('update:outerVis', nv)
    }
  }
}
</script>
